import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHero } from "@/components/PageHero";
import { InsightCard } from "@/components/Cards";
import { Disclaimer } from "@/components/Shared";
import { RESEARCH_DESK } from "@/data/content";

const CATS = ["All", "Index Analysis", "Derivatives Analysis", "Volatility Analysis", "Participant Data"];

export default function Research() {
  const [reports, setReports] = useState([]);
  const [active, setActive] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/research").then((r) => setReports(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = reports.filter((r) => active === "All" || r.category === active);

  return (
    <div data-testid="research-page">
      <PageHero
        eyebrow="Market Insights & Analysis"
        title="Market Insights & Analysis"
        subtitle="Market insights and educational analysis in one place — index and derivatives analysis, volatility and participant data, plus our daily Intraday Analysis and Market Participants notes. Factual data is clearly distinguished from interpretation."
        crumbs={[{ label: "Market Insights" }]}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid lg:grid-cols-4 gap-10">
          <aside className="lg:col-span-1">
            <h3 className="eyebrow text-slate-400 mb-4">Market Insight Categories</h3>
            <div className="space-y-1">
              {CATS.map((c) => (
                <button
                  key={c}
                  data-testid={`research-cat-${c.toLowerCase().replace(/\s/g, "-")}`}
                  onClick={() => setActive(c)}
                  className={`block w-full text-left text-sm px-3 py-2 rounded-md transition-colors ${
                    active === c ? "bg-navy text-white" : "text-slate-600 hover:bg-subtle"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
            <div className="mt-8 bg-subtle border border-border rounded-lg p-5">
              <h4 className="font-display font-semibold text-navy text-sm mb-3">Coverage</h4>
              {RESEARCH_DESK.map((d) => (
                <div key={d.title} className="mb-2.5">
                  <p className="text-xs font-medium text-slate-700">{d.title}</p>
                  <p className="text-xs text-slate-400">{d.items.join(" · ")}</p>
                </div>
              ))}
            </div>
          </aside>
          <div className="lg:col-span-3">
            {loading ? (
              <p className="text-slate-400">Loading research…</p>
            ) : (
              <div className="grid sm:grid-cols-2 gap-6">
                {filtered.map((r) => <InsightCard key={r.slug} report={r} />)}
              </div>
            )}
            <div className="mt-12"><Disclaimer /></div>
          </div>
        </div>
      </div>
    </div>
  );
}
